import React from 'react';
import { theme } from '@fiverr-private/theme';
import { SYSTEM_ICON_SIZES } from '../../constants';
import type { SystemIconType } from '../../types';

const HeartSolidIcon = ({ size = 'sm', color = 'currentColor' }: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 16 14"
  >
    <path d="M14.447.956c-1.713-1.46-4.26-1.197-5.831.425L8 2.016l-.616-.635C5.816-.24 3.266-.503 1.553.956c-1.962 1.675-2.066 4.682-.31 6.497l6.048 6.244a.98.98 0 0 0 1.415 0l6.047-6.244c1.76-1.815 1.656-4.822-.306-6.497" />
  </svg>
);
HeartSolidIcon.id = 'HeartSolidIcon';
HeartSolidIcon.displayName = 'HeartSolidIcon';
export default HeartSolidIcon;
